/*
  The Amulets: pictures, the bag, the bar that follows, and the quiet reveal.
  Read by sections/amulet-product.liquid and sections/amulet-collection.liquid.
*/
(() => {
  if (window.__amuletReady) return;
  window.__amuletReady = true;

  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- The quiet reveal ---------- */
  function reveal(root) {
    const items = $$('.amu-reveal', root);
    if (!items.length || reduce || !('IntersectionObserver' in window)) return;
    root.classList.add('is-motion');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      else io.observe(el);
    });
  }

  /* ---------- The pictures ---------- */
  function gallery(root, onZoom) {
    const track = $('[data-amu-track]', root);
    if (!track) return;
    const slides = $$('[data-amu-slide]', track);
    const thumbs = $$('[data-amu-thumb]', root);
    const bars = $$('.amu-gal__bar i', root);
    const count = $('[data-amu-count]', root);
    const prev = $('[data-amu-prev]', root);
    const next = $('[data-amu-next]', root);
    let index = 0;
    let ticking = false;

    const width = () => track.clientWidth || 1;
    const set = (i) => {
      index = Math.max(0, Math.min(slides.length - 1, i));
      if (count) count.textContent = String(index + 1);
      bars.forEach((b, k) => b.classList.toggle('is-on', k === index));
      thumbs.forEach((t, k) => t.setAttribute('aria-current', k === index ? 'true' : 'false'));
      if (prev) prev.setAttribute('aria-disabled', index === 0 ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', index === slides.length - 1 ? 'true' : 'false');
      const t = thumbs[index];
      if (t && t.parentElement && t.parentElement.scrollHeight > t.parentElement.clientHeight) {
        const p = t.parentElement;
        const top = t.offsetTop - p.offsetTop;
        if (top < p.scrollTop || top + t.offsetHeight > p.scrollTop + p.clientHeight) p.scrollTo({ top: top - 20, behavior: reduce ? 'auto' : 'smooth' });
      }
    };
    const go = (i, smooth = true) => {
      const target = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: target * width(), behavior: smooth && !reduce ? 'smooth' : 'auto' });
      set(target);
    };
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { ticking = false; set(Math.round(track.scrollLeft / width())); });
    }, { passive: true });
    thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
    if (prev) prev.addEventListener('click', () => go(index - 1));
    if (next) next.addEventListener('click', () => go(index + 1));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    });
    $$('[data-amu-zoom]', root).forEach((b) => b.addEventListener('click', () => onZoom && onZoom(Number(b.dataset.amuZoom) || 0, b)));
    window.addEventListener('resize', () => { track.scrollTo({ left: index * width(), behavior: 'auto' }); }, { passive: true });
    set(0);
    return { go };
  }

  /* ---------- Every picture, large ---------- */
  function lightbox(page) {
    const box = $('[data-amu-lightbox]', page);
    if (!box) return null;
    const items = $$('[data-amu-lb-item]', box);
    const close = $('[data-amu-lb-close]', box);
    let opener = null;
    const load = () => items.forEach((img) => {
      if (img.dataset.src && !img.getAttribute('src')) {
        img.setAttribute('srcset', img.dataset.srcset || '');
        img.setAttribute('src', img.dataset.src);
      }
    });
    const onKey = (e) => {
      if (e.key === 'Escape') { e.preventDefault(); shut(); }
      if (e.key === 'Tab' && close) { e.preventDefault(); close.focus(); }
    };
    const shut = () => {
      if (box.hidden) return;
      box.classList.remove('is-open');
      box.hidden = true;
      document.documentElement.classList.remove('amu-lock');
      document.removeEventListener('keydown', onKey, true);
      if (opener) opener.focus({ preventScroll: true });
    };
    const open = (i, from) => {
      opener = from || null;
      load();
      box.hidden = false;
      box.classList.add('is-open');
      document.documentElement.classList.add('amu-lock');
      document.addEventListener('keydown', onKey, true);
      const target = items[i];
      requestAnimationFrame(() => {
        box.scrollTop = 0;
        if (target && i > 0) box.scrollTop = Math.max(0, target.offsetTop - 64);
        if (close) close.focus({ preventScroll: true });
      });
    };
    if (close) close.addEventListener('click', shut);
    box.addEventListener('click', (e) => { if (e.target.tagName === 'IMG') shut(); });
    return open;
  }

  /* ---------- Choosing, and the bag ---------- */
  function buy(page, gal) {
    const form = $('[data-amu-form]', page);
    if (!form) return;
    const input = $('[data-amu-variant]', form);
    const status = $('[data-amu-status]', page);
    const addButtons = $$('[data-amu-add], [data-amu-add-proxy]', page);
    let variants = [];
    let labels = {};
    try { variants = JSON.parse($('[data-amu-variants]', page).textContent); } catch (e) { variants = []; }
    try { labels = JSON.parse($('[data-amu-labels]', page).textContent); } catch (e) { labels = {}; }
    const L = (k, d) => labels[k] || d;
    let current = variants.find((v) => String(v.id) === String(input && input.value)) || variants[0] || null;
    let busy = false;

    const say = (text, isError) => {
      if (!status) return;
      status.textContent = text || '';
      status.classList.toggle('is-error', !!isError);
    };
    const paint = () => {
      if (!current) return;
      if (input) input.value = current.id;
      $$('[data-amu-price]', page).forEach((el) => { el.innerHTML = current.price; });
      $$('[data-amu-compare]', page).forEach((el) => {
        if (current.compare) { el.innerHTML = current.compare; el.hidden = false; } else { el.hidden = true; }
      });
      addButtons.forEach((b) => {
        b.disabled = !current.available;
        const l = $('[data-amu-add-label]', b);
        if (l) l.textContent = current.available ? L('add', 'Add to bag') : L('soldout', 'Sold out');
      });
      const fi = Number(labels.finish_index);
      if (fi >= 0 && current.options[fi]) {
        const finish = current.options[fi];
        $$('[data-amu-metal-name]', page).forEach((el) => { el.textContent = finish; });
        $$('[data-amu-metal-lc]', page).forEach((el) => { el.textContent = finish.toLowerCase(); });
        const note = $('[data-amu-pictured-note]', page);
        if (note) {
          const pictured = String(labels.pictured || '');
          const show = pictured && finish !== pictured && (current.media === null || current.media === undefined);
          note.hidden = !show;
          if (show) note.textContent = String(labels.note || '').replace('[pictured]', pictured.toLowerCase()).replace('[chosen]', finish.toLowerCase());
        }
      }
    };

    $$('[data-amu-option]', page).forEach((group) => {
      group.addEventListener('change', () => {
        const chosen = $$('[data-amu-option]', page).map((g) => {
          const r = $('input:checked', g);
          return { i: Number(g.dataset.amuOption), v: r ? r.value : null };
        });
        const value = $('[data-amu-option-value]', group);
        const checked = $('input:checked', group);
        if (value && checked) value.textContent = checked.value;
        const match = variants.find((v) => chosen.every((c) => c.v === null || v.options[c.i] === c.v));
        if (match) {
          current = match;
          paint();
          say('');
          if (gal && typeof match.media === 'number') gal.go(match.media);
          try {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', match.id);
            window.history.replaceState({}, '', url.toString());
          } catch (e) { /* the address stays as it is */ }
        }
      });
    });

    const openBag = () => {
      const trigger = document.querySelector('.js-open-cart');
      if (trigger) trigger.click();
      else window.location.assign((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart');
    };

    const add = async () => {
      if (busy || !current || !current.available) return;
      busy = true;
      say('');
      addButtons.forEach((b) => {
        b.classList.add('is-busy');
        const l = $('[data-amu-add-label]', b);
        if (l) l.textContent = L('adding', 'Adding…');
      });
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [Object.assign({ id: Number(current.id), quantity: 1 }, labels.property ? { properties: labels.property } : {})] })
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          const why = new Error(data.description || data.message || L('error', 'It could not be added. Please try again.'));
          why.fromShop = true;
          throw why;
        }
        addButtons.forEach((b) => {
          const l = $('[data-amu-add-label]', b);
          if (l) l.textContent = L('added', 'In your bag');
        });
        say(L('added', 'In your bag') + '.');
        openBag();
        setTimeout(() => {
          addButtons.forEach((b) => {
            const l = $('[data-amu-add-label]', b);
            if (l) l.textContent = current.available ? L('add', 'Add to bag') : L('soldout', 'Sold out');
          });
        }, 2600);
      } catch (err) {
        say(err && err.fromShop && err.message ? err.message : L('error', 'It could not be added. Please try again.'), true);
        addButtons.forEach((b) => {
          const l = $('[data-amu-add-label]', b);
          if (l) l.textContent = current.available ? L('add', 'Add to bag') : L('soldout', 'Sold out');
        });
      } finally {
        busy = false;
        addButtons.forEach((b) => b.classList.remove('is-busy'));
      }
    };

    form.addEventListener('submit', (e) => { e.preventDefault(); add(); });
    $$('[data-amu-add-proxy]', page).forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); add(); }));
    paint();
    /* Arriving with ?variant= for a finish that has its own picture: open on that picture. */
    if (gal && current && current !== variants[0] && typeof current.media === 'number') gal.go(current.media, false);
  }

  /* ---------- The bar that follows ---------- */
  /*
    Measured on scroll rather than with an IntersectionObserver: on a phone the button starts below the fold,
    and a jump past it (a link, a restored position) would never cross it, so an observer would never hear of it.
  */
  function sticky(page) {
    const bar = $('[data-amu-sticky]', page);
    const main = $('[data-amu-add]', page);
    if (!bar || !main) return;
    const close = $('.amu-close', page);
    const films = $$('.amu-film', page);
    const footer = document.querySelector('.shopify-section-group-footer-group');
    const inView = (el) => {
      if (!el) return false;
      const r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    };
    let was = null;
    let ticking = false;
    const update = () => {
      ticking = false;
      const on = main.getBoundingClientRect().bottom < 0 && !inView(close) && !inView(footer) && !films.some(inView);
      if (on === was) return;
      was = on;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      $$('button', bar).forEach((b) => { b.tabIndex = on ? 0 : -1; });
    };
    const ask = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask, { passive: true });
    update();
    return () => {
      window.removeEventListener('scroll', ask);
      window.removeEventListener('resize', ask);
    };
  }

  /* ---------- The film, played by the scroll ----------
     The whole file is fetched once the section is near, so every frame is there to seek to; the scroll sets the
     time it heads for and each frame eases toward it. One seek at a time: the next waits for "seeked". */
  function film(root) {
    const stage = $('.amu-film__stage', root);
    const video = $('.amu-film__video', root);
    if (!stage || !video || reduce) return null;
    const glow = $('.amu-film__glow', root);
    const g = glow && glow.getContext ? glow.getContext('2d') : null;
    const first = $('.amu-film__still--first', root);
    const cue = $('[data-amu-film-cue]', root);
    const lines = $$('[data-amu-film-line]', root);
    const clamp = (v) => Math.max(0, Math.min(1, v));
    const fade = (p, a, b, c, d) => (p <= a || p >= d ? 0 : p < b ? (p - a) / (b - a) : p <= c ? 1 : (d - p) / (d - c));
    const windows = lines.length > 1 ? [[0.12, 0.2, 0.42, 0.5], [0.56, 0.64, 2, 3]] : [[0.3, 0.4, 2, 3]];
    let duration = 0;
    let target = 0;
    let current = 0;
    let ready = false;
    let seeking = false;
    let seekAt = 0;
    let frame = 0;
    let started = false;
    let failed = false;

    root.classList.add('is-live');
    first.loading = 'eager';

    /* Held by hand: the theme's body is its own scroll box, which leaves position:sticky with nothing to stick to. */
    const progress = () => {
      const head = parseFloat(getComputedStyle(root).getPropertyValue('--amu-head')) || 0;
      const r = root.getBoundingClientRect();
      const h = stage.offsetHeight;
      const pinned = r.top <= head && r.bottom > head + h;
      root.classList.toggle('is-pinned', pinned);
      root.classList.toggle('is-after', !pinned && r.bottom <= head + h);
      const span = r.height - h;
      return span > 0 ? clamp((head - r.top) / span) : 0;
    };
    const drawGlow = (src) => {
      if (!g || !glow.offsetParent) return;
      try { g.drawImage(src, 0, 0, glow.width, glow.height); } catch (e) { /* not decoded yet */ }
    };
    const paint = (p) => {
      if (cue) cue.style.opacity = String(1 - clamp((p - 0.02) / 0.07));
      lines.forEach((el, i) => {
        const w = windows[i] || windows[windows.length - 1];
        const o = fade(p, w[0], w[1], w[2], w[3]);
        el.style.opacity = o.toFixed(3);
        el.style.transform = `translateY(${((1 - o) * 14).toFixed(1)}px)`;
      });
    };
    const tick = () => {
      frame = 0;
      if (failed) return;
      const p = progress();
      paint(p);
      if (!ready) return;
      target = clamp((p - 0.015) / 0.95) * Math.max(0, duration - 0.04);
      current += (target - current) * 0.2;
      if (Math.abs(target - current) < 0.004) current = target;
      if (seeking && performance.now() - seekAt > 450) seeking = false;
      if (!seeking && Math.abs(video.currentTime - current) > 0.012) {
        seeking = true;
        seekAt = performance.now();
        video.currentTime = current;
      }
      if (current !== target) ask();
    };
    const ask = () => { if (!frame) frame = requestAnimationFrame(tick); };

    video.addEventListener('seeked', () => {
      seeking = false;
      drawGlow(video);
      if (Math.abs(video.currentTime - current) > 0.012 || current !== target) ask();
    });

    const pickSource = () => {
      const wide = window.innerWidth >= 1100;
      const px = (wide ? stage.clientHeight * 9 / 16 : stage.clientWidth) * (window.devicePixelRatio || 1);
      return wide && px > 760 ? root.dataset.srcLg : root.dataset.srcSm;
    };
    const load = async () => {
      if (started) return;
      started = true;
      try {
        /* The film sits right under the pictures: let the page's own pictures arrive first. */
        if (document.readyState !== 'complete') await new Promise((ok) => window.addEventListener('load', ok, { once: true }));
        const res = await fetch(pickSource(), { credentials: 'omit', priority: 'low' });
        if (!res.ok) throw new Error(String(res.status));
        const url = URL.createObjectURL(await res.blob());
        video.src = url;
        video.load();
        await new Promise((ok, fail) => {
          video.addEventListener('loadeddata', ok, { once: true });
          video.addEventListener('error', fail, { once: true });
        });
        duration = video.duration || 0;
        /* iOS paints a seeked frame only once the video has played: a muted play and an instant pause. */
        try { await video.play(); } catch (e) { /* muted inline play may still be refused */ }
        video.pause();
        ready = duration > 0;
        current = 0;
        root.classList.add('is-ready');
        drawGlow(video);
        ask();
      } catch (e) {
        /* No film (a missing file, a codec the browser lacks): back to the still, the artwork with its words. */
        root.classList.add('is-failed');
        root.classList.remove('is-live', 'is-pinned', 'is-after');
        lines.forEach((el) => { el.style.opacity = ''; el.style.transform = ''; });
        if (cue) cue.style.opacity = '';
        failed = true;
      }
    };

    const near = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { near.disconnect(); load(); }
    }, { rootMargin: '150% 0px 150% 0px' });
    near.observe(root);
    if (first.complete) drawGlow(first); else first.addEventListener('load', () => drawGlow(first), { once: true });

    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask, { passive: true });
    paint(progress());
    return () => {
      near.disconnect();
      window.removeEventListener('scroll', ask);
      window.removeEventListener('resize', ask);
    };
  }

  /* Each page of Amulets, set up once: on load, and again when the theme editor re-renders its section. */
  function init(scope) {
    const roots = scope.matches && scope.matches('.amu') ? [scope] : $$('.amu', scope);
    roots.forEach((root) => {
      if (root.__amu) return;
      root.__amu = true;
      reveal(root);
      if (!root.matches('[data-amu-pdp]')) return;
      const open = lightbox(root);
      let gal = null;
      $$('[data-amu-gallery]', root).forEach((g) => { gal = gallery(g, open) || gal; });
      buy(root, gal);
      const stopSticky = sticky(root);
      const stopFilms = $$('[data-amu-film]', root).map((f) => film(f));
      root.__amuStop = () => {
        if (stopSticky) stopSticky();
        stopFilms.forEach((stop) => { if (stop) stop(); });
      };
    });
  }
  const start = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    $$('.amu', e.target).forEach((root) => { if (root.__amuStop) root.__amuStop(); });
  });
})();
